import { processingOrderMsg, t } from '../../../common/i18n';
import { LoadingDialog } from '../../LoadingDialog/LoadingDialog.js';

interface OrderSubmissionProgressModalProps {
  isOpen: boolean;
}

/**
 * Progress modal shown when order submission is in progress.
 * Displays a loading spinner with "Please wait while we process the order..." text.
 */
export const OrderSubmissionProgressModal = ({ isOpen }: OrderSubmissionProgressModalProps) => {
  if (!isOpen) {
    return null;
  }

  return <LoadingDialog loadingText={t.RW6O(processingOrderMsg)} />;
};
